const USER_MANAGMENT_END_POINTS = {
  LOGIN_ADMIN: "v1/api/Login",
  VENDOR_ADMIN_REGISTRATION: "v1/api/Registration/VendorAdmin",
  VENDOR_RESEND_VERIFICATION:
    "v1/api/Verification/VendorAdmin/RequestEmailVerification",
  VERIFICATION_CHECKING: "v1/api/Verification/VerificationChecking",
  REFRESH_TOKEN: "v1/api/Login/RefreshToken",
  Change_Password: "v1/api/UserProfile/change-password",
  FORGET_PASSWORD_REQUEST_OTP: "v1/api/ForgetPassword/RequestOtp",
  FORGET_PASSWORD_VERIFY_OTP: "v1/api/ForgetPassword/VerifyOtp",
  FORGET_PASSWORD_CHANGE_PASSWORD: "v1/api/ForgetPassword/ChangePassword",
};
const GIFT_CARD_ENDPOINTS = {
  TRANSACTION_REPORT: "v1/api/Transactions/report",
  GET_CLIENTS: "v1/api/Client",
  GET_BRANCH_BY_ID: "v1/api/RedemptionChannels",
  ADD_CLIENTS: "v1/api/Client",
  UPDATE_CLIENT: "v1/api/Client",
  GET_CLIENT_PRODUCTS_DETAILS: "v1/api/Clients/GetClientsProductDetails",
  REDEMPTION_CHANNELS: "v1/api/RedemptionChannels",
  POINT_OF_SALES: "v1/api/PointOfSales",
  CHANGE_POINT_OF_SALES_API_KEY: "v1/api/PointOfSales/change-api-key",
  PRODUCTS: "v1/api/Products",
  GET_PRODUCT_ITEMS: "v1/api/ProductItems",
  GET_PRODUCT_ITEM_BY_BARCODE: "v1/api/ProductItems/Barcode",
  GET_LOOKUP_GOVERNORATES: "v1/api/Lookups/Governorates",
  GET_LOOKUP_PRODUCT_TYPES: "v1/api/Lookups/ProductTypes",
  GET_LOOKUP_CLIENTS: "v1/api/Lookups/Clients",
  GET_LOOKUP_PAYMENT_METHODS: "v1/api/Lookups/payment-methods",
  GET_LOOKUP_INVOICE_STATUS: "v1/api/Lookups/invoice-status",
  USER: "v1/api/User",
  BATCHES: "v1/api/ProductBatch",
  UPDATE_BATCH_STATUS: "v1/api/ProductBatch/update-status",
  BATCH_DETAILS: "v1/api/ProductBatch/details",
  INVOICES: "/v1/api/Invoice",
  GENERATE_INVOICE: "v1/api/Invoice/generate",
  INVOICING_REPORT: "v1/api/Invoice/report",
  INVOICE_PAYMENT: "v1/api/PaymentTransaction",
  REPORTING: "v1/api/Reporting",
  DASHBOARD_STATISTICS: "v1/api/Dashboard/Statistics",
  INVOICING_REPORT_STATISTICS: "v1/api/Invoice/summary",
  CHANGE_INVOICE_STATUS: "v1/api/Invoice/invoice-status",
  REDEMPTION_REPORT: "v1/api/RedemptionTrends",
  SALES_REPORT: "v1/api/Products/sales-report",
  INVOICE_TRANSACTIONS: "v1/api/Transactions",
  PRODUCT_INVENTORY_REPORT: "v1/api/Products/product-inventory-report",
  PRODUCT_ITEM_TRANSACTION: "v1/api/Transactions/item/",
  EXPORT_SALES_REPORT: "v1/api/Products/export-sales-report",
  EXPORT_REDEMPTION_REPORT:
    "v1/api/RedemptionTrends/export-redemption-trends-report",
  EXPORT_PRODUCT_INVENTORY_REPORT:
    "/v1/api/Products/export-product-inventory-report",
  EXPORT_TRANSACTION_REPORT: "v1/api/Transactions/export-transaction-report",
  BULK_IMPORT_CLIENTS: "v1/api/BulkImport",
  BULK_IMPORT_CLIENTS_TEMPLATE: "v1/api/BulkImport/download-template",
  ACTIVATE: "v1/api/ProductItemActions/Activate",
  VALIDATE: "v1/api/ProductItemActions/Validate",
  REDEEM: "v1/api/ProductItemActions/Redeem",
  DETAILS: "v1/api/ProductItemActions/Details",
  EXPORT_BATCH_CARDS: "v1/api/ProductBatch/export-cards",
};
const FILE_MANAGMENT_END_POINTS = {
  DOWNLOAD: "v1/api/Storage/Download",
  UPLOAD_FILE: "v1/api/Storage/Upload",
};

export {
  USER_MANAGMENT_END_POINTS,
  GIFT_CARD_ENDPOINTS,
  FILE_MANAGMENT_END_POINTS,
};
